// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__MaVS7","wrapper":"Projects_wrapper__VMD5k"};